import CulturesTemplateDropdown from "components/dropdowns/reactselect/CulturesTemplateDropdown";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import { YesNoRadioGroupForInPageEditing } from "components/ValidatedFields/YesNoRadioGroup";
import React, { useState } from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { ColumnsPanelForNew } from "./ColumnsPanel/ColumnsPanel";
import { ExcelTemplateState } from "./model";
import { useCurrentUser } from "common/SessionContext";

interface ExcelTemplateNewSectionProps {
  mainAreaId: server.dto.MainAreas
  availableMergeFieldTopics: server.dto.AvailableMergeFieldTopic[]
}

export const ExcelTemplateNewSection = (props: ExcelTemplateNewSectionProps) => {
  const currentUser = useCurrentUser();
  const [excelTemplate, setExcelTemplate] = useState<ExcelTemplateState>({
    title: "",
    lcid: currentUser.culture,
    distinctRows: false,

    columns: [],
  });

  const submit = () => {
    return window.CoreApi.ExcelTemplate.CreateExcelTemplate({
      mainAreaId: props.mainAreaId,
      lcid: excelTemplate.lcid,
      title: excelTemplate.title,
      distinctRows: excelTemplate.distinctRows,
      columns: excelTemplate.columns,
    })
  }

  return <EditSectionTemplate
    submit={submit}
    redirectUrl={(id) => routes.excelTemplate_Detail(id).absolute}
    sections={[{
      key: "excelTemplate",
      type: "regular",
      title: RESX.ExcelTemplate.resxExcelTemplate,
      fields: [{
        key: "title",
        label: RESX.GeneralLabels.Title,
        renderEditNew: () => <RequiredTextInput
          validatorKey="title"
          focusOnMount
          maxLength={serverReference.constants.excelTemplate.maxTitleLength}
          value={excelTemplate.title}
          onChange={(title) => { setExcelTemplate({ ...excelTemplate, title }); }}
        />
      }, {
        key: "lcid",
        label: RESX.Language.resxLanguage,
        renderEditNew: () => <CulturesTemplateDropdown
          value={excelTemplate.lcid}
          onChange={(lcid) => setExcelTemplate({ ...excelTemplate, lcid })}
        />
      }, {
        key: "distinctRows",
        label: RESX.ExcelTemplate.UniqueRows,
        renderEditNew: () => <YesNoRadioGroupForInPageEditing
          value={excelTemplate.distinctRows}
          onChange={(distinctRows) => setExcelTemplate({ ...excelTemplate, distinctRows })}
        />,
      }]
    }, {
      key: "columns",
      type: "custom",
      render: () => <ColumnsPanelForNew
        columns={excelTemplate.columns}
        availableMergeFieldTopics={props.availableMergeFieldTopics}
        onColumnsUpdated={(columns) => setExcelTemplate({ ...excelTemplate, columns })}
      />
    }]}
  />
}